<template>
  <div class="ap-view-history">
    <div class="page-list" v-show="!$route.params.id">
      <div style="height: 56px;">
        <div class="title float-left">浏览历史</div>
        <div class="float-right">（近期浏览过的30个商品）</div>
      </div>
      <div>
        <table class="table table-hover font12">
          <thead>
            <tr>
              <th></th>
              <th>商品编号</th>
              <th>商品货号</th>
              <th>类目</th>
              <th style="width:300px">商品名称</th>
              <th>价格</th>
              <th>浏览时间</th>
              <th>状态</th>
              <th style="width:80px"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="cursor:pointer" v-for="it in records" :key="it.id" @click="viewDetail(it.commodityId)">
              <td>
                <div class="img-wrap">
                  <img class="img" v-if="it.dispImgUri" v-lazy="getImgUrl(it.dispImgUri)" />
                  <img class="img no-img" v-else src="@assets/images/no_image.png" />
                </div>
              </td>
              <td>{{it.number}}</td>
              <td>{{it.productNumber}}</td>
              <td>{{it.genCmdtyName}}</td>
              <td>{{it.name}}</td>
              <td style="color:#f03">{{it.salesPrice}}</td>
              <td>{{it.createdTime | toShortDateTime}}</td>
              <td>{{it.publishState}}</td>
              <td class="text-center">
                <a class="btn btn-sm btn-icon btn-secondary" @click.stop="remove(it.id)" style="margin-left:10px">
                  <i class="far fa-trash-alt"></i>
                  <span class="sr-only">Remove</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!records.length" style="margin-top:30px;text-align:center">No data !</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      records: []
    };
  },
  created() {
    this.getData();
    document.title = "51 AUTOPARTS 浏览历史";
  },
  methods: {
    getData() {
      this.$list("/dmhs/histories/query", {})
        .then(res => {
          let commodityIds = [];
          res.forEach(it => {
            it.salesPrice = "";
            commodityIds.push(it.commodityId);
          });
          this.records = res;
          if (!commodityIds.length) return [];
          return this.$post("/crms/salesQuotation/current", { commodityIds });
        })
        .then(res => {
          res.forEach(it1 => {
            this.records.forEach(it2 => {
              if (it1.commodityId == it2.commodityId) it2.salesPrice = it1.salesPrice;
            });
          });
        })
        .catch(err => {});
    },
    remove(id) {
      this.$get("dmhs/histories/delete/" + id, {})
        .then(res => {
          this.getData();
        })
        .catch(err => {});
    },
    viewDetail(id) {
      let routeData = this.$router.resolve({ path: "/sku/" + id });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style lang="less">
.ap-view-history {
  padding: 20px;
  background: #fff;
  .title {
    margin-bottom: 20px;
    font-size: 24px;
  }
  .page-list {
    .table {
      tbody {
        color: #666;
      }
      .order-header {
        td {
          border-right-color: #fff;
          vertical-align: middle;
          &:last-child {
            border-right-color: #ecedf1;
          }
        }
        .col1 a {
          font-weight: bold;
          &:hover {
            font-weight: normal;
          }
        }
      }
    }
    .tb-header {
      margin-top: 10px;
      margin-bottom: 0;
      td {
        border-top: none;
      }
    }
    .order-child {
      background: #f2f2f2;
      &:hover {
        background: #ffc;
      }
    }
    .col1 {
      width: 306px;

      span,
      a {
        display: inline-block;
        vertical-align: top;
      }
      span + span {
        margin-left: 25px;
      }
      a {
        margin-left: 5px;
        width: 100px;
        color: #09c;
        text-align: left;
        &:hover {
          color: #09c;
          text-decoration: underline;
        }
      }
    }
    .col3 {
      width: 150px;
    }
    .col4 {
      width: 114px;
    }
    .col5 {
      width: 126px;
      button {
        padding-top: 2px !important;
        padding-bottom: 2px !important;
      }
    }
  }
  .img-wrap {
    border: 1px solid #e4e4e4;
    width: 82px;
    height: 82px;
    display: flex;
    justify-content: center;
    align-items: center;
    .img[lazy="loading"] {
      width: 35px;
      height: 35px;
    }
    .img[lazy="loaded"] {
      max-width: 100%;
      max-height: 100%;
    }
    .img[lazy="error"],
    .no-img {
      width: 80px;
      height: auto;
    }
  }
}
</style>